import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { Observable } from "rxjs";

@Injectable()
export class DepartmentService {
  private readonly apiPrefix = '/admin/departments'

  constructor(
    private api: ApiService
  ) {
  }

  getDepartments(): Observable<any> {
    return this.api.get(this.apiPrefix);
  }
}
